// Инициализация i18n для веба. Ресурсы перевода подтянуты 1:1 из мобильного
// приложения (asm-rn/app/assets/locales). Язык хранится в localStorage.appLocale.
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import ru from "assets/locales/ru.json";
import en from "assets/locales/en.json";
import de from "assets/locales/de.json";
import fr from "assets/locales/fr.json";
import it from "assets/locales/it.json";
import es from "assets/locales/es.json";
import tr from "assets/locales/tr.json";

export const APP_LOCALE_KEY = "appLocale";

export const SUPPORTED_LOCALES = ["en", "de", "fr", "it", "es", "tr", "ru"] as const;
export type AppLocale = typeof SUPPORTED_LOCALES[number];

const getInitialLocale = (): AppLocale => {
  try {
    const saved = window.localStorage.getItem(APP_LOCALE_KEY) as AppLocale | null;
    if (saved && (SUPPORTED_LOCALES as readonly string[]).includes(saved)) {
      return saved;
    }
  } catch (_) {}
  return "ru";
};

i18n.use(initReactI18next).init({
  resources: {
    ru: { translation: ru },
    en: { translation: en },
    de: { translation: de },
    fr: { translation: fr },
    it: { translation: it },
    es: { translation: es },
    tr: { translation: tr },
  },
  lng: getInitialLocale(),
  fallbackLng: "ru",
  interpolation: { escapeValue: false },
  returnNull: false,
});

export const changeAppLocale = (locale: AppLocale) => {
  try {
    window.localStorage.setItem(APP_LOCALE_KEY, locale);
  } catch (_) {}
  return i18n.changeLanguage(locale);
};

export default i18n;
